import type { Lead } from '../../../shared/types';
import { shell } from '../app';
import { getLead } from '../data/store';
import { h } from '../ui/dom';
import type { View } from '../ui/router';
import { logStep } from './quicklogForm';
import { pickStep } from './quicklogPick';

/**
 * Quick log (~20 s): pick or create a lead → big buttons → notes → next action → Save.
 * `#/log?lead=<id>` skips the picker.
 */
// ---------------------------------------------------------------- view

export const quickLogView: View = async ({ root, query }) => {
  shell.setChrome(true);
  shell.setTitle('Log visit');
  const host = h('div', { class: 'quicklog' });
  root.appendChild(host);
  let cleanup: (() => void) | void;

  const presetId = query.get('lead');
  const returnOverride = query.get('return'); // e.g. "/route" — where Save should land (M2)
  const preset = presetId ? await getLead(presetId) : undefined;
  const start = (lead: Lead, fromPicker: boolean) => {
    if (cleanup) cleanup();
    cleanup = undefined;
    const backTo = returnOverride ? `#${returnOverride}` : `#/leads/${encodeURIComponent(lead.id)}`;
    shell.setTitle('Log visit', { back: fromPicker ? false : backTo });
    void logStep(host, lead, {
      onChangeLead: fromPicker ? () => showPicker() : null,
      returnTo: returnOverride ? `#${returnOverride}` : fromPicker ? '#/home' : `#/leads/${encodeURIComponent(lead.id)}`,
    });
  };
  const showPicker = () => {
    if (cleanup) cleanup();
    shell.setTitle('Log visit');
    cleanup = pickStep(host, (lead) => start(lead, true));
  };

  if (preset) start(preset, false);
  else showPicker();
  return () => {
    if (cleanup) cleanup();
  };
};
